import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';

import { Container } from './styles';

export default function MensagemCreate() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  // Buscando os dados da api

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      // retira o match de parametro por nao estar sendo usado const { id } = match.params;
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/whatsapp', {
        name: data.name,
      });

      toast.success('Integração cadastrado com sucesso');

      reset();
      history.push('/mensagem');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar integração');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastro de Integração de mensagem</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input
            icon="MdPerson"
            name="name"
            label="Nome da integraçao de mensagem"
            type="text"
          />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

MensagemCreate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
